import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- VIDEO ---- -----------------------------*
  // *===============================================---*
  {
    path: '/videos/list',
    name: 'pages-videos-list',
    component: () => import('@/views/pages/video/VideosList.vue'),
    meta: {
      resource: 'video',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('videos.mainVerticalMenu.videos'),
    },
  },
  {
    path: '/videos/add',
    name: 'pages-videos-add',
    component: () => import('@/views/pages/video/VideoAdd.vue'),
    meta: {
      resource: 'video',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('videos.mainVerticalMenu.videos'),
    },
  },
  {
    path: '/videos/edit/:id',
    name: 'pages-videos-edit',
    component: () => import('@/views/pages/video/VideoEdit.vue'),
    meta: {
      resource: 'video',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('videos.mainVerticalMenu.videos'),
    },
  },
]
